//* Libraries imports
import { Card } from "react-bootstrap";
import "./essay-viewer.scss";

//* Components imports
import { PdfViewer } from "./pdf-viewer";
import Icon from "../../../../components/common/Icon";

//* Icons imports
import { FaFileAlt, FaGraduationCap, FaQuoteLeft, FaExclamationTriangle } from "react-icons/fa";

interface EssayViewerProps {
  essay?: {
    title?: string;
    prompt?: string;
    candidateTitle?: string;
    hasCorrections?: boolean;
    correctionStatus?: "NAO_ESCANEADO" | "PENDENTE" | "CORRIGIDA";
    file?: string | null;
    corrections?: Array<{
      id: number;
      image?: string;
    }>;
  };
  hasCriteriosZero?: boolean;
  disableDownload?: boolean;
  downloadPermissions?: {
    canDownload: boolean;
    showButton: boolean;
    requireAuth?: boolean;
  };
}

export function EssayViewer({
  essay,
  hasCriteriosZero = false,
  disableDownload = false,
  downloadPermissions
}: EssayViewerProps) {  
  const pdfUrl = (() => {
    if (essay?.hasCorrections) {
      if (essay.file) {
        return `${process.env.REACT_APP_STORAGE_URL || ''}${essay.file}`;
      }
      if (essay.correctionStatus === "NAO_ESCANEADO") {
        return null;
      }
      return undefined;
    } else {
      // return essay?.corrections?.[0]?.image 
      //   ? `${process.env.REACT_APP_STORAGE_URL || ''}${essay.corrections[0].image}`
      //   : undefined;

      return undefined;
    }
  })();

  const finalPdfUrl = pdfUrl || (process.env.NODE_ENV === 'development' ? '/test-essay.pdf' : undefined);


  const fileName = essay?.title ? `${essay.title}.pdf` : 'essay.pdf';

  const showNotScannedMessage = essay?.hasCorrections && 
                                essay?.correctionStatus === "NAO_ESCANEADO" && 
                                !essay?.file;

  return (
    <div className="essay-container">
      {/* Essay Title and Prompt Section */}
      {essay && (
        <div className="essay-section">
          <Card className="essay-prompt-card shadow-sm">
            {/* Essay Title */}
            {essay.title && (
              <div className="essay-title-section">
                <div className="essay-title-decoration"></div>                <div className="essay-title-content">
                  <div className="essay-title-icon-wrapper">
                    <Icon icon={FaFileAlt} />
                  </div>
                  <div className="essay-title-text">
                    <span className="essay-title-label">Tema da Redação</span>
                    <h1 className="essay-title-value">{essay.title}</h1>
                  </div>
                </div>
              </div>
            )}

            {/* Essay Prompt */}
            {essay.prompt && (
              <div className="essay-prompt-section">                <div className="prompt-header-modern">
                  <div className="prompt-icon-wrapper">
                    <Icon icon={FaQuoteLeft} />
                  </div>
                  <h2 className="prompt-title-modern">Proposta de Redação</h2>
                </div>
                <div className="essay-statement-wrapper">
                  <p className="essay-statement-modern">{essay.prompt}</p>
                </div>
              </div>
            )}
          </Card>
        </div>
      )}

      {/* Candidate Title Section */}
      {essay?.candidateTitle && (
        <div className="essay-section">
          <Card className="candidate-title-card shadow-sm">
            <div className="candidate-title-header">
              <div className="candidate-title-decoration"></div>              <div className="candidate-title-content">
                <div className="candidate-title-icon-wrapper">
                  <Icon icon={FaGraduationCap} />
                </div>
                <div className="candidate-title-text">
                  <span className="candidate-title-label">Título do Candidato</span>
                  <h3 className="candidate-title-value">{essay.candidateTitle}</h3>
                </div>
              </div>
            </div>
          </Card>
        </div>
      )}      
      {/* PDF Viewer Section */}
      <div className="essay-section">
        {showNotScannedMessage ? (
          <Card className="not-scanned-card shadow-sm">            <Card.Body className="text-center p-5">
              <div className="not-scanned-icon mb-3">
                <Icon icon={FaExclamationTriangle} size={48} className="text-warning" />
              </div>
              <h4 className="text-muted mb-3">Redação Não Escaneada</h4>
              <p className="text-muted mb-0">
                Esta redação ainda não foi digitalizada. O arquivo estará disponível 
                assim que o processo de escaneamento for concluído.
              </p>
            </Card.Body>
          </Card>        ) : finalPdfUrl ? (          <PdfViewer
            pdfUrl={finalPdfUrl!}
            fileName={fileName}
            hasCriteriosZero={hasCriteriosZero}
            disableDownload={disableDownload}
            downloadPermissions={downloadPermissions}
          />
        ) : (
          <Card className="pdf-unavailable-card shadow-sm">            <Card.Body className="text-center p-5">
              <div className="unavailable-icon mb-3">
                <Icon icon={FaExclamationTriangle} size={48} className="text-muted" />
              </div>
              <h4 className="text-muted mb-3">PDF Não Disponível</h4>
              <p className="text-muted mb-0">
                O arquivo da redação não está disponível no momento.
              </p>
            </Card.Body>
          </Card>
        )}
      </div>
    </div>
  );
}